import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { NavbarComponent } from './navbar.component';
import { ToastrModule } from 'ngx-toastr';
import { ConfirmDialogModule } from "../../confirm-dialog.module"; 

@NgModule({
    imports: [RouterModule, CommonModule, ConfirmDialogModule, ToastrModule.forRoot({
        timeOut: 5000,
        positionClass: 'toast-top-left',
        preventDuplicates: true,
    })],
    declarations: [NavbarComponent],
    exports: [NavbarComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class NavbarModule {
  
}
